/**
 * Person Normalizr Schema
 */
import { schema } from 'normalizr';

import groupPerson from './groupPerson';

const person = new schema.Entity(
    'people',
    {
        groups: [groupPerson]
    },
    {
        processStrategy: value => ({
            ...value,
            _fullName: `${value.firstName}${value.firstName && ' '}${
                value.lastName
            }`,
            _digest: `${value.firstName}${value.firstName && ' '}${
                value.lastName
            }`
        })
    }
);

export default person;
